var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('div',{staticClass:"cell-left"},[_vm._v(_vm._s(_vm.cellName)),_vm._t("title")],2),_c('div',{staticClass:"cell-right"},[_vm._v(_vm._s(_vm.cellValue)),_vm._t("value")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }